<template>
  <main id="content">
    <section class="hero">
      <b-container>
        <b-row class="justify-content-center">
          <b-col md="7" class="text-center">
            <div class="pt-3 pb-1 mt-5 mb-5">
              <h1 data-aos="fade-down">Watch your data come to life.</h1>
              <p data-aos="fade-down">
                Aura lets you view your as-built in our Patented Augmented
                Reality View instantly. Simply upload your KML files and view
                your mapped underground assets in augmented reality through your
                mobile or tablet. It works so seamlessly that you’ll never want
                to go back to reality.
              </p>
              <!-- <div class="mt-4">
								<b-button :to="'/about'" variant="primary">Get started<font-awesome-icon :icon="faArrowRight" /></b-button>
              </div>-->
            </div>
          </b-col>
        </b-row>
        <div class="text-center">
          <img
            alt="Needle device sideview"
            src="../assets/aura-hero.png"
            class="hero-image"
            data-aos="flip-down"
          />
        </div>
      </b-container>
    </section>
    <section>
      <b-container>
        <h3 class="text-center mb-5" data-aos="fade-up">
          We know you're a go getter.
        </h3>
        <b-row class>
          <b-col md="4">
            <div class="mb-5">
              <div class="h1 mb-3 text-half" data-aos="fade-right">
                <font-awesome-icon icon="camera" />
              </div>
              <h3 class="h5 mb-3" data-aos="fade-right">
                Capture and collaborate
              </h3>
              <p data-aos="fade-right">
                Write down notes as you move, take pictures for any point,
                record videos of your mapped assets, all in our patented
                Augmented Reality view and share them with your team in seconds.
              </p>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mb-5">
              <div class="h1 mb-3 text-half" data-aos="fade-down">
                <font-awesome-icon icon="cloud" />
              </div>
              <h3 class="h5 mb-3" data-aos="fade-down">Cloud sync</h3>
              <p data-aos="fade-down">
                All your settings are synced across all of your devices and our
                incredible cloud based infrastructure stores all your data, so
                that you never have to worry about losing your precious data
                ever again.
              </p>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mb-5">
              <div class="h1 mb-3 text-half" data-aos="fade-left">
                <font-awesome-icon icon="sync" />
              </div>
              <h3 class="h5 mb-3" data-aos="fade-left">
                Real-time automated updates
              </h3>
              <p data-aos="fade-left">
                Aura has automated updates over-the-air so that you can always
                stay up to date with the latest technology and get ahead of the
                competition.
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="cta text-center pl-4 pr-4">
      <h2 data-aos="fade-down">This is the future.</h2>
      <p data-aos="fade-down">Coming soon to Android and iOS devices.</p>
      <div class="mt-4">
        <b-button
          id="btnAuraPreregister"
          class="btn-lg"
          to="/contact"
          variant="primary"
          data-aos="fade-down"
        >
          Preregister for Aura
          <font-awesome-icon icon="arrow-right" />
        </b-button>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
section {
  &.hero {
    color: #fff;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.3)
      ),
      url("https://images.pexels.com/photos/378570/pexels-photo-378570.jpeg?w=1260&h=750&auto=compress&cs=tinysrgb")
        no-repeat bottom center;
    background-size: cover;
    padding: 0;
    p {
      margin: 1rem 0 1.75rem 0;
    }
  }
  &.cta {
    color: #fff;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url("https://images.pexels.com/photos/8092/pexels-photo.jpg?w=1260&h=750&auto=compress&cs=tinysrgb")
        no-repeat center center;
    background-size: cover;
  }
  .hero-image {
    max-height: 450px;
  }
}
@media (max-width: 750px) {
  section.hero {
    padding-top: 3rem;
  }
  .hero-image {
    max-height: 250px;
  }
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: show;
}
</style>
